import { Box, Typography } from '@mui/material'
import { HOME_MOBILE_MQ } from './homeMobileLayout'

export default function HomeTestimonialCard({ name, role, quote, avatar, roleLines }) {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: { xs: 268, lg: 340 },
        [HOME_MOBILE_MQ]: { minHeight: 268 },
        height: 'auto',
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        overflow: 'visible',
        p: { xs: '20px', sm: '22px', lg: '24px' },
        boxSizing: 'border-box',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '40px', sm: '32px', lg: '40px' },
          [HOME_MOBILE_MQ]: { gap: '40px' },
          flex: 1,
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <Box
            sx={{
              position: 'relative',
              width: { xs: 48, sm: 80, lg: 88 },
              height: { xs: 48, sm: 80, lg: 88 },
              [HOME_MOBILE_MQ]: { width: 48, height: 48 },
              borderRadius: '50%',
              flexShrink: 0,
              overflow: 'hidden',
              bgcolor: '#e0e0e0',
            }}
          >
            <Box
              component="img"
              src={avatar}
              alt={name}
              sx={{
                position: 'absolute',
                width: '100%',
                height: '150%',
                left: 0,
                top: '-2.27%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: 0, flex: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: 20, sm: 24, lg: 22 },
                [HOME_MOBILE_MQ]: { fontSize: 20 },
                lineHeight: 'normal',
                fontWeight: 400,
                color: '#111',
              }}
            >
              {name}
            </Typography>
            {roleLines ? (
              <Box sx={{ opacity: 0.6 }}>
                {roleLines.map((line) => (
                  <Typography
                    key={line}
                    sx={{
                      fontSize: { xs: 13, sm: 18, lg: 20 },
                      [HOME_MOBILE_MQ]: { fontSize: 13 },
                      lineHeight: 'normal',
                      fontWeight: 400,
                      color: '#111',
                    }}
                  >
                    {line}
                  </Typography>
                ))}
              </Box>
            ) : (
              <Typography
                sx={{
                  fontSize: { xs: 13, sm: 18, lg: 20 },
                  [HOME_MOBILE_MQ]: { fontSize: 13 },
                  lineHeight: 'normal',
                  fontWeight: 400,
                  color: '#111',
                  opacity: 0.6,
                }}
              >
                {role}
              </Typography>
            )}
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: { xs: 22, sm: 24, lg: 22 },
            [HOME_MOBILE_MQ]: { fontSize: 22 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
          }}
        >
          {quote}
        </Typography>
      </Box>
    </Box>
  )
}
